import React from 'react';
import { View, StyleSheet, Linking } from 'react-native';
import { Typography } from '@hmsexp/component-library';
import { property } from 'lodash';

const InfoSection = ({ title, fields = [], data = {} }) => {
  const formatShortDate = arr => {
    if (!Array.isArray(arr) || arr.length < 3) return arr;

    const [y, m, d] = arr;
    const month = String(m).padStart(2, '0');
    const day = String(d).padStart(2, '0');

    return `${day}/${month}/${y}`;
  };

  const dateKeys = ['response_date', 'checkin_date', 'checkout_date'];

  const getFormattedValue = (key, rawValue) => {
    if (rawValue === null || rawValue === undefined) return '-';

    if (key === 'property') {
      const hotel_id = data?.hotel_id || '';
      return `${hotel_id} ${rawValue} `.trim();
    }

    if (dateKeys.includes(key) && Array.isArray(rawValue)) {
      return formatShortDate(rawValue);
    }

    return String(rawValue);
  };

  return (
    <View style={styles.container}>
      {title && (
        <Typography variant='h6' fontWeightType='regular'>
          {title}
        </Typography>
      )}

      {fields.map((item, index) => {
        const rawValue = data?.[item.key];
        const value = getFormattedValue(item.key, rawValue);
        const isEmail = item.key.toLowerCase().includes('email');

        return (
          <View key={item.key ?? index}>
            <View style={styles.row}>
              <Typography variant='body2' fontWeightType='regular' style={styles.label}>
                {item.label}
              </Typography>

              {isEmail ? (
                <Typography
                  variant='body2'
                  fontWeightType='regular'
                  style={[styles.value, styles.link]}
                  onPress={() => rawValue && Linking.openURL(`mailto:${rawValue}`)}>
                  {value}
                </Typography>
              ) : (
                <Typography variant='body2' fontWeightType='regular' style={styles.value}>
                  {value}
                </Typography>
              )}
            </View>

            {index < fields.length - 1 && <View style={styles.divider} />}
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: 12,
    borderRadius: 12
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 8
  },
  label: {
    color: '#1A1A1A',
    flex: 0.45
  },
  value: {
    color: '#1A1A1A',
    flex: 0.55
  },
  link: {
    color: '#007AFF'
  },
  divider: {
    height: 1,
    backgroundColor: '#E6E6E6',
    marginVertical: 6
  }
});

export default InfoSection;
